import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { RoleGuard } from "app/guards";
import { ImportacionesProvider } from "./importaciones-context";
import { ImportacionesTable } from "./importaciones-table";
import { ImportacionForm } from "./importacion-form";

export function ImportacionesRoutes() {
  return (
    <RoleGuard roles={["empresa:importaciones"]}>
      <ImportacionesProvider>
        <Routes>
          <Route path="/" element={<Outlet />}>
            <Route index element={<ImportacionesTable />} />

            <Route path="add" element={<ImportacionForm />} />

            <Route path=":importacion_id" element={<Outlet />}>
              <Route index element={<Navigate to="edit" replace />} />

              <Route path="edit" element={<ImportacionForm />} />
            </Route>

            <Route path="*" element="Importaciones: Page Not Found" />
          </Route>
        </Routes>
      </ImportacionesProvider>
    </RoleGuard>
  );
}
